// カスタムモジュール
import { plt_microcms } from "../libs/plt_microcms";

// types
import { microCmsAuthType } from "../types/microCmsAuthType";
import { microCmsContentsQueryByCategoryType, microCmsContentsRequestQueryType } from "../types/microCmsQueryTypes";

/**
 * microCMSコンテンツリスト
 * useHomeContents.hooks.tsと違い、このフックではoffsetを指定してページネーションで利用するためのもの。
 * @param microCmsAuth 
 * @param microCmsQueries 
 * @param offset 何件目から取得するか。デフォルト値 = 0
 * @returns 
 */
const useFetchInfoContentsList = async (
  microCmsAuth: microCmsAuthType,
  microCmsQuery: microCmsContentsRequestQueryType,
  offset: number = 0
) => {
  const client = plt_microcms(microCmsAuth.serviceDomain, microCmsAuth.apiKey);

  let isQueryMax = false;

  try {
    const response = await client.get({
      endpoint: microCmsQuery.endpointId,
      queries: {
        limit: microCmsQuery.limit,
        fields: "id,title,publishedAt,eyecatch,category",
        orders: '-publishedAt',
        offset: offset,
      }
    });
    // これ以上クエリする必要があるかどうかの確認
    const nextOffset: number = offset + microCmsQuery.limit;
    isQueryMax = response.totalCount < nextOffset ? true : false;
    return {
      status: "200", 
      responseBody: {contents: response.contents, totalCount: response.totalCount, nextOffset: nextOffset, isQueryMax: isQueryMax}
    }
  } catch (e) {
    console.log(e);
    return { status: "400", responseBody: {}}
  }

}

export default useFetchInfoContentsList;